import { render, staticRenderFns } from "./FormMultipleFiles.vue?vue&type=template&id=b46f001e&"
import script from "./FormMultipleFiles.vue?vue&type=script&lang=js&"
export * from "./FormMultipleFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports